import { ApolloError } from "@apollo/client";

/**
 * Returns the first `extensions.code` from an Apollo error's GraphQL errors,
 * or undefined if the error isn't an ApolloError or doesn't carry a code.
 * Useful for branching UI on server-side error codes like SNAPSHOT_PENDING.
 */
export function getGraphQLErrorCode(error: unknown): string | undefined {
  if (!(error instanceof ApolloError)) return undefined;
  for (const gqlError of error.graphQLErrors ?? []) {
    const code = gqlError.extensions?.code;
    if (typeof code === "string" && code.length > 0) return code;
  }
  return undefined;
}

/**
 * Checks if an error is an authorization/permission error
 */
export function isAuthorizationError(error: unknown): boolean {
  return getGraphQLErrorCode(error) === "FORBIDDEN";
}
